module.exports = __webpack_public_path__ + "img/calendar-solid.5e2c52e0.svg";